import Typography from '@mui/material/Typography';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { useTranslation } from 'react-i18next';

import { getExportTypesLabels, getProvidersLabels, providerFields } from '../../constants.ts';

type AllowedExportTypesFieldProps = {
  allowedExportTypes: string[];
};

export const AllowedExportTypesField = ({ allowedExportTypes }: AllowedExportTypesFieldProps) => {
  const { t } = useTranslation();
  const exportTypes = getExportTypesLabels(t);
  const providersLabels = getProvidersLabels(t);

  return (
    <>
      <Typography sx={{ color: 'text.secondary', mb: 1 }}>
        {providersLabels[providerFields.ALLOWED_EXPORT_TYPES]}
      </Typography>

      {Object.entries(exportTypes).map(([exportType, label]) => (
        <FieldDetails
          checkbox
          value={allowedExportTypes.includes(exportType)}
          title={label}
          data-test="export-type-readonly-checkbox"
          key={exportType}
        />
      ))}
    </>
  );
};
